<template>
  <div id="footer" class="container-fluid">
    <div class="footer-inner page-container">
      <div class="logo">
        <BrandLogo size="lg" to="/" />
      </div>
      <p class="slogan">{{ config.slogan }}</p>
      <p class="title">{{ config.name }}</p>
      <div class="contact-grid">
        <p><span class="label">地址</span>{{ config.address }}</p>
        <p><span class="label">联系人</span>{{ config.mobileContact }}</p>
        <p><span class="label">座机</span><a :href="'tel:' + config.tel.replace(/-/g, '')">{{ config.tel }}</a></p>
        <p><span class="label">电话</span><a :href="'tel:' + config.mobile">{{ config.mobile }}</a></p>
        <p><span class="label">邮箱</span><a :href="'mailto:' + config.email.trim()">{{ config.email }}</a></p>
        <p><span class="label">传真</span>{{ config.fax }}</p>
        <p><span class="label">微信</span>{{ config.wechat }}</p>
      </div>
      <p class="copy">Copyright &copy; 2020 - 2026 <a href="http://beian.miit.gov.cn/" target="_blank">{{ config.keepOnRecordIcp }}</a></p>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import BrandLogo from '@/components/BrandLogo'
export default {
  name: "Footer",
  components: { BrandLogo },
  data() {
    return { config };
  }
};
</script>
<style scoped>
#footer {
  color: #e2e8f0;
  background: linear-gradient(180deg, #0a1628 0%, #060d18 100%);
  padding: 50px 20px 30px;
  text-align: center;
  border-top: 1px solid rgba(56, 139, 253, 0.15);
  box-shadow: 0 -20px 60px rgba(26, 111, 181, 0.06);
}
.logo {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}
.logo /deep/ .brand-logo {
  justify-content: center;
}
.slogan { font-size: 13px; letter-spacing: 2px; opacity: 0.75; margin-bottom: 12px; }
.title { font-size: 20px; font-weight: 600; margin-bottom: 24px; }
.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 24px;
  max-width: 640px;
  margin: 0 auto 30px;
  text-align: left;
  font-size: 14px;
  color: rgba(255,255,255,0.85);
}
.contact-grid p { margin: 0; line-height: 1.8; }
.contact-grid .label { display: inline-block; width: 72px; opacity: 0.7; }
.contact-grid a { color: #38bdf8; text-decoration: none; }
.contact-grid a:hover { text-decoration: underline; }
.copy { color: #64748b; font-size: 13px; padding-top: 20px; border-top: 1px solid rgba(56, 139, 253, 0.12); }
.copy a { color: #94a3b8; }
@media screen and (max-width: 768px) {
  .contact-grid { grid-template-columns: 1fr; }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue